export const getCookieRootDomain = () => {
  const rootDomain = window.location.hostname.replace(/^[^.]+\./, '');
  return `.${ rootDomain }`;
};
